<template>
  <div class="description">
    <form class="description-form">
      <label class="description-label" for="description-text">Описание объекта защиты</label>
      <textarea
        class="description-textarea"
        id="description-text"
        v-model="description"
        placeholder="Введите текст"
        max-rows="10"
      />
    </form>

    <div class="modal-footer-buttons">
      <main-button :loading="loading" type="button" @click="save()">Сохранить</main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import MainButton from "../../components/ui/MainButton.vue";
export default {
  components: { MainButton },
  name: "Description",
  props: {
    project: Object,
    fetchData: Function,
  },
  data() {
    return {
      description: "",
      loading: false,
    };
  },
  methods: {
    save() {
      this.loading = true;
      this.$http
        .post("projects/description-update?id=" + this.project.id, {
          description: this.description,
        })
        .then(() => {
          this.fetchData();
          this.$emit("descriptionHide");
        })
        .catch((e) => {
          alert("Что-то не так", e);
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.description = this.project.description;
  },
};
</script>

<style scoped>
.description {
  padding: 0;
}
.description-form {
  display: flex;
  flex-direction: column;
  padding: 0 24px 36px;
}
.description-label {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-bottom: 4px;
  color: var(--black-color);
}
.description-textarea {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-radius: 3px;
  border: 1px solid var(--border-color);
  min-height: 80px;
  color: var(--grey-3-color);
  padding: 5px 8px;
}
</style>
